/* ------------------------------------------------------------------
   Unwind Designs, flat-pack configurator (13 Sep 2026)

   Plain ES2017, one IIFE, no build step, no libraries.
   Everything it knows comes from the single
   <script type="application/json" data-fc-data> block the section emits
   (schema flatpack_config/1) plus data attributes in the DOM. There is not
   one kit specific string in this file, so the same module drives Wander,
   Roam 2.0, Premium, the 5-Seater and anything Karim adds later.

   Progressive enhancement only. With this file blocked the page is still a
   working product page: native radios, checkboxes and selects, server
   rendered prices and captions, and the base kit variant still adds to cart.
   Every optional browser feature is feature detected before use.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  /* ---------------- tiny helpers ---------------- */

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function isArr(a) { return Object.prototype.toString.call(a) === '[object Array]'; }
  function trim(s) { return String(s == null ? '' : s).replace(/^\s+|\s+$/g, ''); }
  function reduceMotion() {
    try {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) { return false; }
  }

  /* ---------------- one configurator ---------------- */

  function boot(root) {
    if (!root || root.getAttribute('data-fc-init') === '1') return;

    var dataEl = qs('[data-fc-data]', root);
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent || dataEl.innerHTML); } catch (e) { return; }
    if (!D || D.schema !== 'flatpack_config/1' || !isArr(D.groups)) return;
    root.setAttribute('data-fc-init', '1');

    var S = D.settings || {};
    var CUR = (D.product && D.product.currency) || 'AUD';
    var MEDIA = isArr(D.media) ? D.media : [];
    var GROUPS = D.groups;

    var sel = {};   /* group key    -> option key, or array of keys for multi */
    var vsel = {};  /* option uid   -> variant id chosen in that card         */
    var txt = {};   /* group key    -> free text for an own option            */
    var cfgId = '';
    var lastComplete = '';
    var interacted = false; /* completion is only reported after a real change */
    var soft = false; /* true while the module is rewriting inputs itself */

    /* ---------------- money ---------------- */

    function money(cents) {
      var c = Math.round(Number(cents) || 0);
      var dp = (c % 100 === 0) ? 0 : 2;
      try {
        return new Intl.NumberFormat('en-AU', {
          style: 'currency', currency: CUR,
          minimumFractionDigits: dp, maximumFractionDigits: dp
        }).format(c / 100);
      } catch (e) {
        return '$' + (c / 100).toFixed(dp);
      }
    }
    function plain(cents) {
      var c = Math.round(Number(cents) || 0);
      return (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    /* ---------------- lookups ---------------- */

    function group(key) {
      for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].key === key) return GROUPS[i];
      return null;
    }
    function optsOf(g) { return (g && isArr(g.options)) ? g.options : []; }

    function reqMet(o) {
      var r = isArr(o.requires) ? o.requires : [];
      for (var i = 0; i < r.length; i++) {
        var p = String(r[i]).split(':');
        var gk = trim(p[0]), ok = trim(p[1]);
        if (!gk || !ok) continue;
        var cur = sel[gk];
        if (cur === undefined || cur === null) return false;
        if (isArr(cur)) { if (cur.indexOf(ok) < 0) return false; }
        else if (cur !== ok) return false;
      }
      return true;
    }
    function excHit(o) {
      var r = isArr(o.excludes) ? o.excludes : [];
      for (var i = 0; i < r.length; i++) {
        var p = String(r[i]).split(':');
        var gk = trim(p[0]), ok = trim(p[1]);
        if (!gk || !ok) continue;
        var cur = sel[gk];
        if (isArr(cur)) { if (cur.indexOf(ok) >= 0) return titleOf(gk, ok); }
        else if (cur === ok) return titleOf(gk, ok);
      }
      return '';
    }
    function titleOf(gk, ok) {
      var g = group(gk), o = optsOf(g);
      for (var i = 0; i < o.length; i++) if (o[i].key === ok) return o[i].title || ok;
      return ok;
    }
    /* Two cards in one group may share a key (a kit specific add-on gated by
       requires). The live one is the one whose requires are met. */
    function pick(g, key) {
      var o = optsOf(g), first = null;
      for (var i = 0; i < o.length; i++) {
        if (o[i].key !== key) continue;
        if (first === null) first = o[i];
        if (reqMet(o[i]) && !excHit(o[i])) return o[i];
      }
      return first;
    }
    function selectedOf(g) {
      var out = [];
      if (!g) return out;
      var cur = sel[g.key];
      if (cur === undefined || cur === null) return out;
      var keys = isArr(cur) ? cur : [cur];
      for (var i = 0; i < keys.length; i++) {
        var o = pick(g, keys[i]);
        if (o) out.push(o);
      }
      return out;
    }
    function eachSelected(cb) {
      for (var i = 0; i < GROUPS.length; i++) {
        var g = GROUPS[i], list = selectedOf(g);
        for (var j = 0; j < list.length; j++) cb(g, list[j]);
      }
    }
    function firstDefault(g) {
      var o = optsOf(g), i;
      for (i = 0; i < o.length; i++) {
        if (o[i].mode === 'included' && reqMet(o[i]) && !excHit(o[i])) return o[i];
      }
      for (i = 0; i < o.length; i++) {
        if (reqMet(o[i]) && !excHit(o[i]) && o[i].mode !== 'quote' && o[i].mode !== 'own') return o[i];
      }
      for (i = 0; i < o.length; i++) if (reqMet(o[i]) && !excHit(o[i])) return o[i];
      return null;
    }

    /* ---------------- variants ---------------- */

    function valueFor(gkey, key) {
      var g = group(gkey);
      if (!g) return null;
      var o = optsOf(g);
      for (var i = 0; i < o.length; i++) if (o[i].key === key) return o[i].value;
      return null;
    }
    function kitVariant() {
      var li = D.layoutOptionIndex, fi = D.finishOptionIndex;
      var lv = li >= 0 ? valueFor('layout', sel.layout) : null;
      var fv = fi >= 0 ? valueFor('finish', sel.finish) : null;
      var i, v;
      for (i = 0; i < D.variants.length; i++) {
        v = D.variants[i];
        if (lv !== null && v.options[li] !== lv) continue;
        if (fv !== null && v.options[fi] !== fv) continue;
        return v;
      }
      for (i = 0; i < D.variants.length; i++) if (D.variants[i].available) return D.variants[i];
      return D.variants[0] || null;
    }
    function variantOfOpt(o) {
      if (!isArr(o.variants) || !o.variants.length) return null;
      var want = vsel[o.uid], i;
      for (i = 0; i < o.variants.length; i++) if (o.variants[i].id === want) return o.variants[i];
      for (i = 0; i < o.variants.length; i++) if (o.variants[i].available) return o.variants[i];
      return o.variants[0];
    }
    function priceOfOpt(o) {
      if (o.mode !== 'product') return 0;
      var v = variantOfOpt(o);
      return v ? v.price : (o.price || 0);
    }
    function total() {
      var kv = kitVariant();
      var t = kv ? kv.price : (D.product.priceMin || 0);
      eachSelected(function (g, o) { t += priceOfOpt(o); });
      return t;
    }
    function hasQuote() {
      var found = false;
      eachSelected(function (g, o) { if (o.mode === 'quote') found = true; });
      return found;
    }
    function quoteUrl() {
      var url = '';
      eachSelected(function (g, o) { if (o.mode === 'quote' && !url && o.quoteUrl) url = o.quoteUrl; });
      return url;
    }

    /* ---------------- DOM refs ---------------- */

    var form = null;
    var atc = qs('[data-fc-atc]', root);
    if (atc) form = atc.form;
    var priceVal = qs('[data-fc-price-value]', root);
    var priceLab = qs('[data-fc-pricelab]', root);
    var vidInput = qs('[data-fc-vid]', root);
    var sumRows = qs('[data-fc-summary-rows]', root);
    var sumExc = qs('[data-fc-summary-exc]', root);
    var sumLead = qs('[data-fc-summary-lead]', root);
    var sumTotal = qs('[data-fc-total]', root);
    var live = qs('[data-fc-live]', root);
    var bar = qs('[data-fc-sticky]', root);
    var barPrice = qs('[data-fc-sticky-price]', root);
    var barBtn = qs('[data-fc-sticky-btn]', root);
    var cartErr = qs('[data-fc-cart-error]', root);
    var btLink = qs('[data-fc-bt]', root);
    /* kit deposit (D10): the pay-mode choice ships hidden and only shows when the
       section settings name an available deposit product (S.deposit). */
    var DEP = (S.deposit && S.deposit.id) ? S.deposit : null;
    var payMode = 'full';
    var payBox = qs('[data-fc-pay]', root);
    var payFull = qs('[data-fc-pay-full]', root);
    var payDep = qs('[data-fc-pay-dep]', root);
    var payNote = qs('[data-fc-paynote]', root);
    var qPanel = qs('[data-fc-quote-panel]', root);
    var qSummary = qs('[data-fc-quote-summary]', root);
    var qPreview = qs('[data-fc-quote-preview]', root);
    var qReturn = qs('[data-fc-returnto]', root);
    var qAttr = qs('[data-fc-attr]', root);
    var qForm = qSummary ? qSummary.form : null;
    var doneCard = qs('[data-fc-done]', root);

    /* gallery */
    var mainImg = qs('[data-fc-mainimg]', root);
    var mainWrap = qs('[data-fc-main]', root);
    var thumbWrap = qs('[data-fc-thumbs]', root);
    var capText = qs('[data-fc-caption]', root);
    var capExtras = qs('[data-fc-extras]', root);
    var shownWrap = qs('[data-fc-shown]', root);
    var shownPrice = qs('[data-fc-shown-price]', root);
    var cfgWrap = qs('[data-fc-configure-wrap]', root);
    var cfgBtn = qs('[data-fc-configure]', root);
    var sticker = qs('[data-fc-sticker]', root);
    var mainVid = qs('[data-fc-mainvid]', root);
    var mainPlay = qs('[data-fc-mainplay]', root);
    var lb = qs('[data-fc-lb]', root);
    var lbStage = lb ? qs('[data-fc-lb-stage]', lb) : null;
    var lbSingle = false;   /* true while the lightbox shows one clip, not the gallery */
    var lbReturn = null;    /* element to hand focus back to on close */
    var mainInView = false;
    var cur = 0;

    /* ---------------- state in and out of the DOM ---------------- */

    function readDom() {
      sel = {}; vsel = {}; txt = {};
      GROUPS.forEach(function (g) { if (g.selection === 'multi') sel[g.key] = []; });
      qsa('[data-fc-input]', root).forEach(function (inp) {
        if (!inp.checked) return;
        var g = inp.getAttribute('data-fc-group'), k = inp.getAttribute('data-fc-key');
        if (inp.type === 'checkbox') {
          if (!isArr(sel[g])) sel[g] = [];
          if (sel[g].indexOf(k) < 0) sel[g].push(k);
        } else { sel[g] = k; }
      });
      qsa('[data-fc-variant-select]', root).forEach(function (s) {
        var n = parseInt(s.value, 10);
        if (!isNaN(n)) vsel[s.getAttribute('data-fc-uid')] = n;
      });
      qsa('[data-fc-text]', root).forEach(function (t) {
        if (t.value) txt[t.getAttribute('data-fc-group')] = t.value;
      });
      GROUPS.forEach(function (g) {
        if (g.selection === 'multi') return;
        if (sel[g.key] === undefined && !g.variantBacked) {
          var d = firstDefault(g);
          if (d && d.mode === 'included') sel[g.key] = d.key;
        }
      });
    }

    function syncDom() {
      soft = true;
      qsa('[data-fc-input]', root).forEach(function (inp) {
        var g = inp.getAttribute('data-fc-group'), k = inp.getAttribute('data-fc-key');
        var uid = inp.getAttribute('data-fc-uid');
        var curSel = sel[g];
        var on;
        if (isArr(curSel)) on = curSel.indexOf(k) >= 0;
        else on = curSel === k;
        /* a duplicate key resolves to exactly one live card */
        if (on) {
          var g2 = group(g), chosen = g2 ? pick(g2, k) : null;
          if (chosen && chosen.uid && uid && chosen.uid !== uid) on = false;
        }
        if (inp.checked !== on) inp.checked = on;
        var card = inp.closest ? inp.closest('[data-fc-card]') : null;
        if (card) card.classList.toggle('is-on', on);
        var tx = card ? qs('[data-fc-text]', card) : null;
        if (tx) {
          tx.disabled = !on;
          tx.required = on;
          if (on && txt[g] !== undefined && tx.value !== txt[g]) tx.value = txt[g];
          if (!on) tx.value = '';
        }
      });
      qsa('[data-fc-variant-select]', root).forEach(function (s) {
        var uid = s.getAttribute('data-fc-uid');
        if (vsel[uid] !== undefined && String(s.value) !== String(vsel[uid])) s.value = String(vsel[uid]);
      });
      soft = false;
    }

    /* ---------------- compatibility ---------------- */

    /* A card whose requires is unmet hides outright (Karim, 13 Sep 2026:
       "when chest is selected only show chest fridge and when upright is
       selected you can click the bushman upright 85L"). */
    function applyVisibility() {
      GROUPS.forEach(function (g) {
        optsOf(g).forEach(function (o) {
          var card = qs('[data-fc-card][data-fc-uid="' + o.uid + '"]', root);
          if (!card) return;
          var vis = reqMet(o);
          card.hidden = !vis;
          var blockedBy = vis ? excHit(o) : '';
          var inp = qs('[data-fc-input]', card);
          var why = qs('[data-fc-why]', card);
          if (inp) inp.disabled = !!blockedBy;
          card.classList.toggle('is-off', !!blockedBy);
          if (why) {
            if (blockedBy) {
              why.textContent = 'Not available with ' + blockedBy + ' selected.';
              why.hidden = false;
            } else { why.textContent = ''; why.hidden = true; }
          }
        });
      });
    }

    function enforce() {
      var notes = [];
      GROUPS.forEach(function (g) {
        var curSel = sel[g.key];
        if (g.selection === 'multi') {
          if (!isArr(curSel)) { sel[g.key] = []; return; }
          sel[g.key] = curSel.filter(function (k) {
            var o = pick(g, k);
            return !!(o && reqMet(o) && !excHit(o));
          });
          return;
        }
        var o = curSel ? pick(g, curSel) : null;
        var ok = o && reqMet(o) && !excHit(o) && variantOk(g, o);
        if (ok) return;
        var d = firstDefault(g);
        var replacement = null;
        if (d && variantOk(g, d)) replacement = d;
        if (!replacement) {
          var list = optsOf(g);
          for (var i = 0; i < list.length; i++) {
            if (reqMet(list[i]) && !excHit(list[i]) && variantOk(g, list[i])) { replacement = list[i]; break; }
          }
        }
        /* An optional group never auto-selects anything that costs money or
           needs a quote. An included option may fill the gap; otherwise the
           group simply stays unselected. */
        if (!g.required && replacement && replacement.mode !== 'included') replacement = null;
        if (replacement) {
          if (curSel !== replacement.key) {
            if (curSel) notes.push((g.property || g.title || g.key) + ' reset to ' + replacement.title + '. The previous choice does not fit the current selection.');
            sel[g.key] = replacement.key;
          }
        } else if (curSel) {
          notes.push((g.property || g.title || g.key) + ' cleared. The previous choice does not fit the current selection.');
          delete sel[g.key];
        }
      });
      if (notes.length && live) live.textContent = notes.join(' ');
      else if (live && !notes.length) live.textContent = '';
    }

    /* A variant backed value has to exist as a real, available variant in
       combination with the other variant backed group. */
    function variantOk(g, o) {
      if (!g.variantBacked) return true;
      var i = g.optionIndex;
      if (i < 0) return true;
      var otherIdx = (i === D.layoutOptionIndex) ? D.finishOptionIndex : D.layoutOptionIndex;
      var otherKey = (i === D.layoutOptionIndex) ? 'finish' : 'layout';
      var otherVal = otherIdx >= 0 ? valueFor(otherKey, sel[otherKey]) : null;
      for (var v = 0; v < D.variants.length; v++) {
        var vv = D.variants[v];
        if (vv.options[i] !== o.value) continue;
        if (otherVal !== null && vv.options[otherIdx] !== otherVal) continue;
        if (vv.available) return true;
      }
      return false;
    }

    /* ---------------- price chips ---------------- */

    function updateChips() {
      GROUPS.forEach(function (g) {
        if (g.variantBacked) {
          var i = g.optionIndex;
          var otherIdx = (i === D.layoutOptionIndex) ? D.finishOptionIndex : D.layoutOptionIndex;
          var otherKey = (i === D.layoutOptionIndex) ? 'finish' : 'layout';
          var otherVal = otherIdx >= 0 ? valueFor(otherKey, sel[otherKey]) : null;
          var mins = {}, base = null, k;
          D.variants.forEach(function (v) {
            if (otherVal !== null && v.options[otherIdx] !== otherVal) return;
            var val = v.options[i];
            if (mins[val] === undefined || v.price < mins[val]) mins[val] = v.price;
          });
          for (k in mins) { if (base === null || mins[k] < base) base = mins[k]; }
          optsOf(g).forEach(function (o) {
            var card = qs('[data-fc-card][data-fc-uid="' + o.uid + '"]', root);
            if (!card) return;
            var chip = qs('[data-fc-chip]', card);
            var have = mins[o.value];
            var avail = variantOk(g, o);
            card.classList.toggle('is-off', !avail);
            var inp = qs('[data-fc-input]', card);
            var why = qs('[data-fc-why]', card);
            if (chip) {
              if (have === undefined) chip.textContent = 'Not made in this combination';
              else if (base !== null && have > base) chip.textContent = '+' + money(have - base);
              else chip.textContent = S.basePriceChip || 'Base price';
            }
            if (!avail) {
              if (inp && sel[g.key] !== o.key) inp.disabled = true;
              if (why) { why.textContent = have === undefined ? 'Not made in this combination.' : 'Sold out in this combination.'; why.hidden = false; }
            } else if (inp && !excHit(o)) {
              inp.disabled = false;
              if (why) { why.textContent = ''; why.hidden = true; }
            }
          });
          return;
        }
        optsOf(g).forEach(function (o) {
          if (o.mode !== 'product') return;
          var card = qs('[data-fc-card][data-fc-uid="' + o.uid + '"]', root);
          if (!card) return;
          var chip = qs('[data-fc-chip]', card);
          if (chip) chip.textContent = '+' + money(priceOfOpt(o));
        });
      });
    }

    /* ---------------- summary, price, properties ---------------- */

    /* Delta a variant backed value adds over the cheapest value of its group,
       with the other variant backed group held at its current selection.
       Same maths as the chips, so the summary and the cards never disagree. */
    function variantDelta(g, o) {
      if (!g || !g.variantBacked || g.optionIndex < 0) return 0;
      var i = g.optionIndex;
      var otherIdx = (i === D.layoutOptionIndex) ? D.finishOptionIndex : D.layoutOptionIndex;
      var otherKey = (i === D.layoutOptionIndex) ? 'finish' : 'layout';
      var otherVal = otherIdx >= 0 ? valueFor(otherKey, sel[otherKey]) : null;
      var mins = {}, base = null, k;
      D.variants.forEach(function (v) {
        if (otherVal !== null && v.options[otherIdx] !== otherVal) return;
        var val = v.options[i];
        if (mins[val] === undefined || v.price < mins[val]) mins[val] = v.price;
      });
      for (k in mins) { if (base === null || mins[k] < base) base = mins[k]; }
      var have = mins[o.value];
      if (have === undefined || base === null || have <= base) return 0;
      return have - base;
    }
    function labelFor(g, o) {
      if (o.mode === 'quote') return S.quoteChip || 'To quote';
      if (o.mode === 'own') return S.ownChip || 'You supply it';
      if (o.mode === 'product') return '+' + money(priceOfOpt(o));
      if (o.mode === 'variant') {
        var d = variantDelta(g, o);
        return d > 0 ? '+' + money(d) : (S.basePriceChip || 'Base price');
      }
      return S.includedChip || 'Included';
    }
    function titleWithText(g, o) {
      var t = o.title || o.key;
      if (o.needsText && txt[g.key]) t += ' (' + txt[g.key] + ')';
      var v = o.mode === 'product' ? variantOfOpt(o) : null;
      /* brackets, not a comma: the Add-ons property is itself a comma list */
      if (v && isArr(o.variants) && o.variants.length > 1) t += ' (' + (v.label || v.title) + ')';
      return t;
    }

    function updateSummary() {
      if (!sumRows) return;
      var rows = [], excs = [];
      GROUPS.forEach(function (g) {
        var list = selectedOf(g);
        list.forEach(function (o) {
          rows.push(
            '<li><span class="ufc__sumk"><b>' + esc(g.property || g.title || g.key) + '</b>' +
            esc(titleWithText(g, o)) + '</span>' +
            '<span class="ufc__sumv">' + esc(labelFor(g, o)) + '</span>' +
            '<button type="button" class="ufc__sumedit" data-fc-edit="' + esc(g.key) + '">' +
            esc(S.editLabel || 'Edit') + '</button></li>'
          );
          if (o.exc) excs.push(o.exc);
        });
      });
      if (!rows.length) {
        rows.push('<li><span class="ufc__sumk"><b>Kit</b>' + esc(D.product.title) + '</span>' +
          '<span class="ufc__sumv">' + esc(S.basePriceChip || 'Base price') + '</span></li>');
      }
      sumRows.innerHTML = rows.join('');
      if (sumExc) {
        if (excs.length) {
          sumExc.innerHTML = excs.map(function (x) {
            return '<li><span class="ufc__mark ufc__mark--no" aria-hidden="true">&#10007;</span><span>' + esc(x) + '</span></li>';
          }).join('');
          sumExc.hidden = false;
        } else { sumExc.innerHTML = ''; sumExc.hidden = true; }
      }
      if (sumLead) sumLead.hidden = !(D.product && D.product.leadTime);
      var t = total();
      if (sumTotal) sumTotal.textContent = hasQuote() ? (money(t) + ' plus the quoted items') : money(t);
    }

    function updatePrice() {
      var t = total();
      if (priceVal) priceVal.textContent = money(t);
      var kv = kitVariant();
      if (priceLab) priceLab.hidden = !(kv && t !== kv.price);
      if (barPrice) barPrice.textContent = money(t);
      if (vidInput && kv) vidInput.value = kv.id;
    }

    function updateProps() {
      var kv = kitVariant();
      qsa('[data-fc-prop]', root).forEach(function (inp) {
        var gk = inp.getAttribute('data-fc-prop');
        var g = group(gk);
        if (!g) { inp.value = ''; return; }
        if (g.variantBacked && kv) { inp.value = kv.options[g.optionIndex] || ''; return; }
        var list = selectedOf(g);
        inp.value = list.map(function (o) { return titleWithText(g, o); }).join(', ');
      });
      var urlInp = qs('[data-fc-prop-url]', root);
      if (urlInp) urlInp.value = params();
    }

    /* kit deposit: true only when the deposit is offered, chosen, and the build
       has no quote-only option (a quoted build goes to the quote form instead). */
    function isDeposit() { return !!(DEP && payMode === 'deposit' && !hasQuote()); }

    function updatePay() {
      if (!payBox || !DEP) return;
      var t = total();
      payBox.hidden = hasQuote();
      if (payFull) payFull.textContent = money(t) + ' ' + (S.depFullSuffix || 'today');
      if (payDep) payDep.textContent = (S.depBalPrefix || 'Balance of') + ' ' + money(Math.max(0, t - DEP.price)) + ' ' + (S.depBalSuffix || 'before dispatch');
      if (payNote) payNote.hidden = !isDeposit();
      /* the bank transfer line is a pay-in-full route, so it steps aside for a deposit */
      var bt = btLink && btLink.closest ? btLink.closest('.ufc__bt') : null;
      if (bt) bt.hidden = isDeposit();
      /* the shipping note says freight is added at checkout, which is not true
         for a deposit (freight goes on the balance invoice), so it steps aside too */
      var ship = qs('.ufc__ship', root);
      if (ship) ship.hidden = isDeposit();
    }

    function updateCta() {
      var q = hasQuote();
      var kv = kitVariant();
      var soldOut = !(kv && kv.available);
      var label = soldOut ? 'Sold out' : (q ? (S.quoteLabel || 'Send this configuration to Unwind') : (isDeposit() ? DEP.atcLabel : (S.atcLabel || 'Add kit to cart')));
      if (atc) {
        atc.textContent = label;
        atc.disabled = soldOut;
        atc.setAttribute('data-fc-quote-mode', q ? '1' : '0');
      }
      if (barBtn) barBtn.textContent = label;
    }

    function updateBankTransfer() {
      if (!btLink) return;
      var base = btLink.getAttribute('data-fc-bt-base');
      if (!base) return;
      var kv = kitVariant();
      var t = total();
      var href = base +
        '&opt=' + encodeURIComponent(kv ? kv.title : '') +
        '&amt=' + encodeURIComponent(plain(t));
      if (kv && t !== kv.price) {
        var lines = [], cart = [];
        lines.push('1 x ' + D.product.title + (kv.title && kv.title !== 'Default Title' ? ' (' + kv.title + ')' : '') + ' = ' + plain(kv.price));
        cart.push(kv.id + ':1');
        eachSelected(function (g, o) {
          if (o.mode !== 'product') return;
          var v = variantOfOpt(o);
          if (!v) return;
          lines.push('1 x ' + o.title + (v.label && v.label !== 'Default Title' ? ' (' + v.label + ')' : '') + ' = ' + plain(v.price));
          cart.push(v.id + ':1');
        });
        href += '&items=' + encodeURIComponent(lines.join('; ')) + '&cart=' + encodeURIComponent(cart.join(','));
      }
      btLink.setAttribute('href', href);
    }

    /* ---------------- url params ---------------- */

    function ourKeys() {
      var keys = [];
      GROUPS.forEach(function (g) {
        keys.push(g.key);
        keys.push(g.key + '_model');
        optsOf(g).forEach(function (o) { keys.push('v_' + g.key + '_' + o.key); });
      });
      return keys;
    }

    function params() {
      var parts = [];
      GROUPS.forEach(function (g) {
        var curSel = sel[g.key];
        if (curSel === undefined || curSel === null) return;
        var val = isArr(curSel) ? curSel.join(',') : curSel;
        if (!val) return;
        parts.push(encodeURIComponent(g.key) + '=' + encodeURIComponent(val));
        if (txt[g.key]) parts.push(encodeURIComponent(g.key + '_model') + '=' + encodeURIComponent(txt[g.key]));
        selectedOf(g).forEach(function (o) {
          if (o.mode !== 'product' || !isArr(o.variants) || o.variants.length < 2) return;
          var v = variantOfOpt(o);
          if (v) parts.push('v_' + encodeURIComponent(g.key) + '_' + encodeURIComponent(o.key) + '=' + v.id);
        });
      });
      return parts.join('&');
    }

    function updateUrl() {
      var qsNow = params();
      var full;
      try {
        var u = new URL(window.location.href);
        ourKeys().forEach(function (k) { u.searchParams.delete(k); });
        var keep = u.searchParams.toString();
        u.search = keep ? (keep + (qsNow ? '&' + qsNow : '')) : qsNow;
        full = u.toString();
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', full);
      } catch (e) {
        full = (S.shopUrl || '') + (S.path || '') + (qsNow ? '?' + qsNow : '');
      }
      qsa('[data-fc-more]', root).forEach(function (a) {
        var href = a.getAttribute('data-fc-more-base') || a.getAttribute('href') || '';
        if (!a.getAttribute('data-fc-more-base')) a.setAttribute('data-fc-more-base', href.split('?')[0]);
        var b = a.getAttribute('data-fc-more-base');
        var back = (S.path || window.location.pathname) + (qsNow ? '?' + qsNow : '');
        a.setAttribute('href', b + '?return=' + encodeURIComponent(back));
      });
      if (qReturn) qReturn.value = (S.path || window.location.pathname) + (qsNow ? '?' + qsNow : '');
      return full;
    }

    function absoluteUrl() {
      var qsNow = params();
      var origin = S.shopUrl || (window.location.origin || '');
      var path = S.path || window.location.pathname;
      return origin + path + (qsNow ? '?' + qsNow : '');
    }

    /* Apply a query string style config, from the page URL or a media note. */
    function applyConfig(str, announce) {
      if (!str) return false;
      var pairs = String(str).replace(/^[?#]/, '').split('&');
      var map = {};
      pairs.forEach(function (p) {
        if (!p) return;
        var i = p.indexOf('=');
        var k = i < 0 ? p : p.slice(0, i);
        var v = i < 0 ? '' : p.slice(i + 1);
        try { map[decodeURIComponent(k)] = decodeURIComponent(v.replace(/\+/g, ' ')); }
        catch (e) { map[k] = v; }
      });
      var touched = false;
      /* layout and finish first: everything else depends on them */
      ['layout', 'finish'].forEach(function (gk) { if (map[gk] !== undefined) { if (setGroup(gk, map[gk])) touched = true; } });
      GROUPS.forEach(function (g) {
        if (g.key === 'layout' || g.key === 'finish') return;
        if (map[g.key] !== undefined) { if (setGroup(g.key, map[g.key])) touched = true; }
        if (map[g.key + '_model'] !== undefined) { txt[g.key] = map[g.key + '_model']; touched = true; }
        optsOf(g).forEach(function (o) {
          var vk = 'v_' + g.key + '_' + o.key;
          if (map[vk] === undefined) return;
          var n = parseInt(map[vk], 10);
          if (isNaN(n) || !isArr(o.variants)) return;
          for (var i = 0; i < o.variants.length; i++) if (o.variants[i].id === n) { vsel[o.uid] = n; touched = true; }
        });
      });
      if (touched && announce && live) live.textContent = 'Configuration applied from the picture.';
      return touched;
    }

    function setGroup(gk, raw) {
      var g = group(gk);
      if (!g) return false;
      if (g.selection === 'multi') {
        var want = String(raw).split(',').map(trim).filter(Boolean);
        var keep = [];
        want.forEach(function (k) { if (pick(g, k)) keep.push(k); });
        sel[gk] = keep;
        return true;
      }
      var key = trim(raw);
      if (!key) return false;
      if (!pick(g, key)) return false;
      sel[gk] = key;
      return true;
    }

    /* ---------------- gallery ---------------- */

    function noteAt(i) { return MEDIA[i] || null; }

    function pricedConfig(cfgStr) {
      if (!cfgStr) return null;
      var keepSel = JSON.parse(JSON.stringify(sel));
      var keepV = JSON.parse(JSON.stringify(vsel));
      var keepT = JSON.parse(JSON.stringify(txt));
      var out = null;
      applyConfig(cfgStr, false);
      if (!hasQuote()) out = total();
      sel = keepSel; vsel = keepV; txt = keepT;
      return out;
    }

    function typeOf(m) { return (m && m.type) || 'image'; }

    /* HLS only on Apple's engine (iPhone, iPad, Safari), where it is native
       and streams at the size the screen needs. Other browsers can answer
       "maybe" for HLS and then fail, so they get the mp4. If a stream still
       errors, the element falls back to the mp4 once. */
    var hlsOk = null;
    function canHls() {
      if (hlsOk === null) {
        try {
          hlsOk = /Apple/.test(navigator.vendor || '') &&
            !!document.createElement('video').canPlayType('application/vnd.apple.mpegurl');
        } catch (e) { hlsOk = false; }
      }
      return hlsOk;
    }
    function videoSrc(m) { return (m.hls && canHls()) ? m.hls : (m.video || m.hls || ''); }
    function mp4Fallback(v, mp4) {
      v.setAttribute('data-fc-mp4', mp4 || '');
      if (v.getAttribute('data-fc-fb') === '1') return;
      v.setAttribute('data-fc-fb', '1');
      v.addEventListener('error', function () {
        var alt = v.getAttribute('data-fc-mp4');
        if (alt && v.getAttribute('src') && v.getAttribute('src') !== alt) {
          v.setAttribute('src', alt);
          try { v.load(); } catch (e) {}
        }
      });
    }

    /* The main slot plays a product video muted and looped, only while it is
       on screen and only when reduced motion is off. Otherwise it shows the
       poster and a play glyph, and a tap opens it in the lightbox. */
    function mainVideoSync() {
      if (!mainVid) return;
      var m = MEDIA[cur];
      var want = !mainVid.hidden && typeOf(m) === 'video' && mainInView && !reduceMotion() &&
        !(lb && lb.classList.contains('is-open'));
      if (want) {
        try {
          mainVid.muted = true;
          var p = mainVid.play();
          if (p && p['catch']) p['catch'](function () {});
        } catch (e) {}
      } else if (!mainVid.paused) {
        try { mainVid.pause(); } catch (e2) {}
      }
    }

    function showMainMedia(m) {
      var t = typeOf(m);
      if (mainWrap) {
        mainWrap.classList.toggle('is-vid', t === 'video');
        mainWrap.classList.toggle('is-ext', t === 'external_video');
        mainWrap.classList.toggle('is-portrait', t !== 'image' && Number(m.aspect) > 0 && Number(m.aspect) < 1);
        mainWrap.setAttribute('aria-label', t === 'image' ? 'View photo full screen' : 'Play video full screen');
      }
      if (t === 'video' && videoSrc(m) && mainWrap) {
        if (!mainVid) {
          mainVid = document.createElement('video');
          mainVid.className = 'ufc__mainvid';
          mainVid.setAttribute('data-fc-mainvid', '');
          mainVid.setAttribute('playsinline', '');
          mainVid.setAttribute('muted', '');
          mainVid.setAttribute('loop', '');
          mainVid.setAttribute('preload', 'metadata');
          mainVid.muted = true;
          mainWrap.insertBefore(mainVid, mainWrap.firstChild);
        }
        if (mainVid.getAttribute('data-fc-idx') !== String(cur)) {
          qsa('source', mainVid).forEach(function (n) { mainVid.removeChild(n); });
          mainVid.setAttribute('poster', m.src);
          mainVid.setAttribute('src', videoSrc(m));
          mainVid.setAttribute('data-fc-idx', String(cur));
          mp4Fallback(mainVid, m.video);
        }
        mainVid.setAttribute('aria-label', m.alt || D.product.title);
        mainVid.hidden = false;
        mainImg.hidden = true;
      } else {
        if (mainVid) {
          try { mainVid.pause(); } catch (e) {}
          mainVid.hidden = true;
        }
        mainImg.hidden = false;
        mainImg.src = m.src;
      }
      mainImg.alt = m.alt || D.product.title;
      if (mainPlay) mainPlay.hidden = !(t === 'external_video' || (t === 'video' && reduceMotion()));
      mainVideoSync();
    }

    function setMain(i, fromOption) {
      if (!MEDIA.length || !mainImg) return;
      cur = (i + MEDIA.length) % MEDIA.length;
      var m = MEDIA[cur];
      showMainMedia(m);
      if (thumbWrap) {
        qsa('[data-fc-thumb]', thumbWrap).forEach(function (b) {
          var on = parseInt(b.getAttribute('data-fc-thumb'), 10) === cur;
          b.classList.toggle('is-on', on);
          if (on && !fromOption && b.scrollIntoView && !reduceMotion()) {
            try { thumbWrap.scrollTo({ left: b.offsetLeft - (thumbWrap.clientWidth - b.clientWidth) / 2, behavior: 'smooth' }); } catch (e) {}
          }
        });
      }
      if (capText) capText.textContent = m.caption || S.defaultCaption || '';
      if (capExtras) {
        var ex = isArr(m.extras) ? m.extras : [];
        capExtras.innerHTML = ex.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('');
        capExtras.hidden = !ex.length;
      }
      if (sticker) sticker.hidden = m.role !== 'base_kit';
      if (cfgWrap) cfgWrap.hidden = !m.config;
      if (cfgBtn && m.config) cfgBtn.setAttribute('data-fc-config', m.config);
      if (shownWrap && shownPrice) {
        var p = m.config ? pricedConfig(m.config) : null;
        if (p !== null && p !== undefined) { shownPrice.textContent = money(p); shownWrap.hidden = false; }
        else { shownWrap.hidden = true; }
      }
    }

    function jumpToTag(tag) {
      if (!tag) return;
      for (var i = 0; i < MEDIA.length; i++) {
        if (MEDIA[i].config && MEDIA[i].config.indexOf(tag) >= 0) { setMain(i, true); return; }
      }
    }

    /* ---------------- lightbox: photos, video, embeds ---------------- */

    /* Remove any playing clip or embed so nothing keeps playing unseen. */
    function lbClear() {
      if (!lbStage) return;
      qsa('video, iframe', lbStage).forEach(function (n) {
        try { if (n.pause) n.pause(); } catch (e) {}
        if (n.parentNode) n.parentNode.removeChild(n);
      });
    }

    /* item: {type:'image'|'video'|'external_video'|'embed', full, src, video, embed, alt, title} */
    function lbRender(item) {
      var img = lbStage ? qs('img', lbStage) : qs('img', lb);
      lbClear();
      var t = item.type || 'image';
      lb.classList.toggle('is-media', t !== 'image');
      if (t === 'image') {
        if (img) { img.hidden = false; img.src = item.full || item.src; img.alt = item.alt || D.product.title; }
        return;
      }
      if (img) { img.hidden = true; img.removeAttribute('src'); }
      if (!lbStage) return;
      if (t === 'video') {
        var v = document.createElement('video');
        v.className = 'ufc__lbvid';
        v.setAttribute('controls', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('preload', 'metadata');
        if (item.src) v.setAttribute('poster', item.src);
        v.setAttribute('aria-label', item.alt || item.title || D.product.title);
        v.src = item.video;
        if (item.mp4) mp4Fallback(v, item.mp4);
        lbStage.appendChild(v);
        /* A tap asked for this clip, so it starts. Reduced motion: it waits
           for the play button instead. */
        if (!reduceMotion()) {
          try { var p = v.play(); if (p && p['catch']) p['catch'](function () {}); } catch (e) {}
        }
        return;
      }
      var f = document.createElement('iframe');
      f.className = 'ufc__lbframe' + (item.tall ? ' is-tall' : '');
      f.setAttribute('src', item.embed);
      f.setAttribute('title', item.title || item.alt || D.product.title);
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen; accelerometer; gyroscope');
      f.setAttribute('allowfullscreen', '');
      lbStage.appendChild(f);
    }

    function lbOpenChrome(multi, countText) {
      var count = qs('.ufc__lbcount', lb);
      if (count) count.textContent = countText || '';
      var prev = qs('[data-fc-lb-prev]', lb), next = qs('[data-fc-lb-next]', lb);
      if (prev) prev.style.display = multi ? 'flex' : 'none';
      if (next) next.style.display = multi ? 'flex' : 'none';
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('ufc-lb-on');
      if (mainVid && !mainVid.paused) { try { mainVid.pause(); } catch (e) {} }
      var close = qs('[data-fc-lb-close]', lb);
      if (close) close.focus();
    }

    function lbShow(i) {
      if (!lb || !MEDIA.length) return;
      if (!lb.classList.contains('is-open')) { lbSingle = false; lbReturn = null; }
      if (lbSingle) return;
      cur = (i + MEDIA.length) % MEDIA.length;
      var m = MEDIA[cur];
      var t = typeOf(m);
      lbRender({ type: t, full: m.full, src: m.src, video: videoSrc(m), mp4: m.video, embed: m.embed, alt: m.alt });
      lbOpenChrome(MEDIA.length > 1, (cur + 1) + ' / ' + MEDIA.length);
    }

    /* One clip on its own: the walkthrough, the 3D viewer or an owner video. */
    function lbOne(item, trigger) {
      if (!lb) return false;
      lbSingle = true;
      lbReturn = trigger || null;
      lbRender(item);
      lbOpenChrome(false, '');
      return true;
    }

    function lbClose() {
      if (!lb) return;
      lbClear();
      lb.classList.remove('is-open');
      lb.classList.remove('is-media');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('ufc-lb-on');
      var wasSingle = lbSingle;
      lbSingle = false;
      if (wasSingle) {
        if (lbReturn && lbReturn.focus) lbReturn.focus();
        lbReturn = null;
        mainVideoSync();
        return;
      }
      setMain(cur, true);
      if (mainWrap) mainWrap.focus();
    }

    /* Which walkthrough or 3D link fits the selected layout. Falls back to
       whichever exists. */
    function byLayout(up, chest) {
      var l = String(sel.layout || '').toLowerCase();
      if (l.indexOf('chest') >= 0) return chest || up;
      if (l.indexOf('upright') >= 0) return up || chest;
      return up || chest;
    }
    function isFileVideo(u) { return /\.(mp4|m4v|webm|mov)(\?|#|$)/i.test(String(u || '')); }

    /* ---------------- share this build ---------------- */

    var shareWrap = qs('[data-fc-share-wrap]', root);
    var shareBtn = qs('[data-fc-share]', root);
    var shareMsg = qs('[data-fc-share-msg]', root);
    var shareTimer = null;
    function shareSay(msg) {
      if (!shareMsg) return;
      shareMsg.textContent = msg;
      shareMsg.classList.add('is-on');
      if (shareTimer) clearTimeout(shareTimer);
      shareTimer = setTimeout(function () { shareMsg.classList.remove('is-on'); shareMsg.textContent = ''; }, 3200);
    }
    function copyText(text) {
      return new Promise(function (resolve) {
        try {
          if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext !== false) {
            navigator.clipboard.writeText(text).then(function () { resolve(true); }, function () { resolve(legacyCopy(text)); });
            return;
          }
        } catch (e) {}
        resolve(legacyCopy(text));
      });
    }
    function legacyCopy(text) {
      var ok = false;
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed'; ta.style.top = '0'; ta.style.left = '0'; ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        ok = document.execCommand && document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (e) { ok = false; }
      return !!ok;
    }
    function isPhone() {
      try { return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches); } catch (e) { return false; }
    }
    function shareBuild() {
      updateUrl();
      var link = absoluteUrl();
      track('kit_config_shared', { selected_value: params() });
      if (isPhone() && navigator.share) {
        try {
          navigator.share({ title: D.product.title, url: link }).then(function () {}, function (err) {
            /* AbortError means they closed the sheet on purpose: say nothing. */
            if (err && err.name === 'AbortError') return;
            copyText(link).then(function (ok) { shareSay(ok ? (S.shareCopied || 'Link copied') : (S.shareFail || 'Copy the link from your address bar')); });
          });
          return;
        } catch (e) {}
      }
      copyText(link).then(function (ok) { shareSay(ok ? (S.shareCopied || 'Link copied') : (S.shareFail || 'Copy the link from your address bar')); });
    }
    if (shareWrap && shareBtn) shareWrap.hidden = false;

    /* ---------------- analytics ---------------- */

    function track(name, extra) {
      var kv = kitVariant();
      var payload = {
        event: name,
        product_handle: D.product.handle,
        configuration_id: cfgId || '',
        base_price: kv ? kv.price / 100 : (D.product.priceMin || 0) / 100,
        configured_total: total() / 100,
        build_method: sel.build_method || ''
      };
      if (extra) { for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k]; }
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
      } catch (e) {}
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          var copy = {}; for (var j in payload) if (j !== 'event') copy[j] = payload[j];
          window.Shopify.analytics.publish(name, copy);
        }
      } catch (e2) {}
    }

    function completeSig() {
      var parts = [];
      var done = true;
      GROUPS.forEach(function (g) {
        if (g.selection === 'multi') { parts.push(g.key + '=' + (sel[g.key] || []).join('+')); return; }
        if (g.required && !sel[g.key]) done = false;
        parts.push(g.key + '=' + (sel[g.key] || ''));
      });
      return done ? parts.join('|') : '';
    }
    function maybeComplete() {
      if (!interacted) return;
      var sig = completeSig();
      if (!sig || sig === lastComplete) return;
      lastComplete = sig;
      track('flatpack_configuration_completed', {});
    }

    /* ---------------- configuration id ---------------- */

    function makeId() {
      var t = Date.now().toString(36);
      t = t.slice(-4);
      var r = Math.floor(Math.random() * 1296).toString(36);
      while (r.length < 2) r = '0' + r;
      return 'UD-' + (t + r).toUpperCase().slice(0, 6);
    }

    /* ---------------- quote summary ---------------- */

    function configSummary() {
      var segs = [D.product.title];
      GROUPS.forEach(function (g) {
        var list = selectedOf(g);
        if (g.key === 'addons') return;
        if (!list.length) return;
        segs.push(list.map(function (o) {
          var t = o.title || o.key;
          if (o.needsText && txt[g.key]) t += ' (own: ' + txt[g.key] + ')';
          return t;
        }).join(' + '));
      });
      var ag = group('addons');
      var addons = ag ? selectedOf(ag).map(function (o) { return titleWithText(ag, o); }) : [];
      segs.push('addons: ' + (addons.length ? addons.join(', ') : 'none'));
      segs.push('total: ' + (hasQuote() ? 'to quote' : money(total())));
      segs.push('config: ' + (cfgId || (cfgId = makeId())));
      segs.push('link: ' + absoluteUrl());
      return segs.join(' | ');
    }

    function updateQuote() {
      if (qSummary) qSummary.value = configSummary();
      if (qPreview) qPreview.textContent = qSummary ? qSummary.value : '';
    }

    /* ---------------- attribution, copied from the bank transfer form ------- */

    function captureAttribution() {
      try {
        if (!qAttr || !window.URLSearchParams) return;
        var ap = new URLSearchParams(window.location.search);
        var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
        var parts = [];
        for (var ai = 0; ai < keys.length; ai++) {
          var av = ap.get(keys[ai]);
          if (av) parts.push(keys[ai] + '=' + av);
        }
        var attrVal = '';
        if (parts.length) {
          attrVal = parts.join(' | ');
          try { window.sessionStorage.setItem('uds-attr', attrVal); } catch (e1) {}
        } else {
          var stored = null;
          try { stored = window.sessionStorage.getItem('uds-attr'); } catch (e2) {}
          if (stored) {
            attrVal = stored;
          } else if (document.referrer) {
            var host = '';
            try { host = new URL(document.referrer).hostname; } catch (e3) {}
            attrVal = host ? 'referrer=' + host : 'direct';
          } else {
            attrVal = 'direct';
          }
        }
        if (attrVal) qAttr.value = attrVal;
      } catch (err) {}
    }

    /* ---------------- cart ---------------- */

    function propsForKit() {
      var out = {};
      qsa('[data-fc-prop]', root).forEach(function (inp) {
        var name = (inp.name || '').replace(/^properties\[/, '').replace(/\]$/, '');
        if (name && inp.value) out[name] = inp.value;
      });
      qsa('[data-fc-text]', root).forEach(function (t) {
        if (t.disabled || !t.value) return;
        var name = (t.name || '').replace(/^properties\[/, '').replace(/\]$/, '');
        if (name) out[name] = t.value;
      });
      out['Configuration ID'] = cfgId;
      out._fc_config = params();
      return out;
    }

    function addToCart() {
      if (!atc || atc.disabled) return;
      var kv = kitVariant();
      if (!kv) return;
      cfgId = makeId();
      var idInp = qs('[data-fc-prop-cfgid]', root);
      if (idInp) idInp.value = cfgId;
      var urlInp2 = qs('[data-fc-prop-url]', root);
      if (urlInp2) urlInp2.value = params();
      if (isDeposit()) {
        postItems([depositItem(kv)], 'flatpack_deposit_add_to_cart', { pay_mode: 'deposit' });
        return;
      }
      var items = [{ id: kv.id, quantity: 1, properties: propsForKit() }];
      eachSelected(function (g, o) {
        if (o.mode !== 'product') return;
        var v = variantOfOpt(o);
        if (!v || !v.available) return;
        items.push({
          id: v.id, quantity: 1,
          properties: {
            'Configuration ID': cfgId,
            'Part of': D.product.title + ' (' + cfgId + ')'
          }
        });
      });
      postItems(items, 'flatpack_configured_add_to_cart', { pay_mode: DEP ? 'full' : '' });
    }

    /* Kit deposit (D10): ONE line, the unlisted Kit Deposit product, carrying the
       whole build. Visible properties are for the customer and Karim; the _ ones
       let the balance draft order be built exactly (kit variant, add-on variants,
       the config string that reopens this build). The kit and add-ons are NOT
       added: they are invoiced with the balance before dispatch. */
    function depositItem(kv) {
      var t = total();
      var kp = propsForKit();
      var props = { 'Kit': D.product.title };
      for (var k in kp) {
        if (!Object.prototype.hasOwnProperty.call(kp, k)) continue;
        if (k.charAt(0) === '_' || k === 'Configuration ID') continue;
        props[k] = kp[k];
      }
      var names = [], ids = [];
      eachSelected(function (g, o) {
        if (o.mode !== 'product') return;
        var v = variantOfOpt(o);
        if (!v || !v.available) return;
        names.push(o.title + (v.label && v.label !== 'Default Title' ? ' (' + v.label + ')' : ''));
        ids.push(v.id + ':1');
      });
      if (names.length) props['Add-ons'] = names.join(', ');
      props['Build total'] = money(t);
      props['Balance before dispatch'] = money(Math.max(0, t - DEP.price));
      props['Freight'] = S.depFreight || 'Invoiced with the balance';
      props['Configuration ID'] = cfgId;
      props['_kit_variant'] = String(kv.id);
      if (ids.length) props['_addon_variants'] = ids.join(',');
      props['_fc_config'] = params();
      props['_fc_link'] = absoluteUrl();
      return { id: DEP.id, quantity: 1, properties: props };
    }

    function postItems(items, evt, extra) {
      if (!window.fetch) { if (form) form.submit(); return; }
      atc.disabled = true;
      if (cartErr) { cartErr.hidden = true; cartErr.textContent = ''; }
      var ex = { items: items.length };
      if (extra) { for (var xk in extra) if (Object.prototype.hasOwnProperty.call(extra, xk) && extra[xk]) ex[xk] = extra[xk]; }
      track(evt, ex);
      window.fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      }).then(function () {
        window.location.href = '/cart';
      })['catch'](function () {
        atc.disabled = false;
        if (cartErr) {
          cartErr.textContent = S.cartError || 'That did not add. Try again, and if it keeps failing, give us a call.';
          cartErr.hidden = false;
        }
      });
    }

    /* ---------------- the one update pass ---------------- */

    function update(reason) {
      applyVisibility();
      enforce();
      applyVisibility();
      syncDom();
      updateChips();
      updatePrice();
      updateSummary();
      updateProps();
      updatePay();
      updateCta();
      updateBankTransfer();
      updateUrl();
      updateQuote();
      maybeComplete();
      if (reason) { /* reason is only used by the caller for analytics */ }
    }

    /* ---------------- events ---------------- */

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (soft || !t) return;
      interacted = true;
      if (t.hasAttribute && t.hasAttribute('data-fc-input')) {
        var g = t.getAttribute('data-fc-group'), k = t.getAttribute('data-fc-key');
        var gr = group(g);
        if (gr && gr.selection === 'multi') {
          if (!isArr(sel[g])) sel[g] = [];
          var at = sel[g].indexOf(k);
          if (t.checked && at < 0) sel[g].push(k);
          if (!t.checked && at >= 0) sel[g].splice(at, 1);
        } else if (t.checked) {
          sel[g] = k;
          var o = gr ? pick(gr, k) : null;
          if (o && o.galleryTag) jumpToTag(o.galleryTag);
        }
        update('option');
        track('flatpack_option_selected', { option_group: g, selected_value: k });
        return;
      }
      if (t.hasAttribute && t.hasAttribute('data-fc-paymode')) {
        if (t.checked) payMode = t.value === 'deposit' ? 'deposit' : 'full';
        update('pay');
        track('flatpack_pay_mode_selected', { pay_mode: payMode });
        return;
      }
      if (t.hasAttribute && t.hasAttribute('data-fc-variant-select')) {
        var n = parseInt(t.value, 10);
        if (!isNaN(n)) vsel[t.getAttribute('data-fc-uid')] = n;
        update('variant');
        track('flatpack_option_selected', {
          option_group: t.getAttribute('data-fc-group'),
          selected_value: t.getAttribute('data-fc-key')
        });
      }
    });

    root.addEventListener('input', function (e) {
      var t = e.target;
      if (soft || !t || !t.hasAttribute || !t.hasAttribute('data-fc-text')) return;
      txt[t.getAttribute('data-fc-group')] = t.value;
      updateProps(); updateSummary(); updateUrl(); updateQuote();
    });

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var edit = t.closest('[data-fc-edit]');
      if (edit) {
        var g = document.getElementById('ufc-g-' + edit.getAttribute('data-fc-edit'));
        if (g) {
          try { g.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' }); }
          catch (e1) { g.scrollIntoView(); }
          g.focus();
        }
        return;
      }

      /* Optional extras list: jump to the option group and land focus on
         its first card so the shopper can pick straight away. */
      var jump = t.closest('[data-fc-jump]');
      if (jump) {
        var jk = jump.getAttribute('data-fc-jump');
        var jg = document.getElementById('ufc-g-' + jk);
        if (jg) {
          /* start, not center: a tall group centred would put its heading
             above the fold. scroll-margin-top on the group clears the header. */
          try { jg.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' }); }
          catch (e3) { jg.scrollIntoView(); }
          var jfirst = qs('[data-fc-input]:not(:disabled)', jg);
          if (jfirst && jfirst.focus) { try { jfirst.focus({ preventScroll: true }); } catch (e4) { jfirst.focus(); } }
          else jg.focus();
          track('flatpack_extra_jump', { group: jk });
        }
        return;
      }

      var thumb = t.closest('[data-fc-thumb]');
      if (thumb) { setMain(parseInt(thumb.getAttribute('data-fc-thumb'), 10)); return; }

      var watch = t.closest('[data-fc-watch]');
      if (watch) {
        var wu = byLayout(watch.getAttribute('data-fc-wt-up'), watch.getAttribute('data-fc-wt-chest'));
        if (!wu) return;
        var wp = wu === watch.getAttribute('data-fc-wt-up') ? watch.getAttribute('data-fc-wt-up-poster') : watch.getAttribute('data-fc-wt-chest-poster');
        var wtitle = watch.getAttribute('data-fc-title') || '';
        var witem = isFileVideo(wu) ?
          { type: 'video', video: wu, src: wp || '', alt: wtitle, title: wtitle } :
          { type: 'embed', embed: wu, title: wtitle };
        if (lbOne(witem, watch)) {
          e.preventDefault();
          track('kit_walkthrough_opened', { selected_value: sel.layout || '' });
        }
        return;
      }

      var spin = t.closest('[data-fc-spin]');
      if (spin) {
        var su = byLayout(spin.getAttribute('data-fc-3d-up'), spin.getAttribute('data-fc-3d-chest'));
        if (!su) return;
        if (lbOne({ type: 'embed', embed: su, tall: true, title: spin.getAttribute('data-fc-title') || '' }, spin)) {
          e.preventDefault();
          track('kit_3d_opened', { selected_value: sel.layout || '' });
        }
        return;
      }

      var ocard = t.closest('[data-fc-play]');
      if (ocard) {
        var ou = ocard.getAttribute('data-fc-play');
        if (!ou) return;
        var otitle = ocard.getAttribute('data-fc-title') || '';
        if (lbOne({ type: 'video', video: ou, src: ocard.getAttribute('data-fc-poster') || '', alt: otitle, title: otitle }, ocard)) {
          e.preventDefault();
          track('owner_video_played', { selected_value: otitle });
        }
        return;
      }

      if (t.closest('[data-fc-share]')) { shareBuild(); return; }

      var conf = t.closest('[data-fc-configure]');
      if (conf) {
        interacted = true;
        track('configure_this_build_clicked', { selected_value: conf.getAttribute('data-fc-config') || '' });
        applyConfig(conf.getAttribute('data-fc-config'), true);
        update('configure');
        return;
      }

      var open = t.closest('[data-fc-quote-open]');
      if (open && qPanel) {
        e.preventDefault();
        qPanel.open = true;
        updateQuote();
        try { qPanel.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' }); }
        catch (e2) { qPanel.scrollIntoView(); }
        var sm = qs('summary', qPanel);
        if (sm) sm.focus();
        return;
      }

      if (t.closest('[data-fc-lb-close]')) { lbClose(); return; }
      if (t.closest('[data-fc-lb-prev]')) { e.stopPropagation(); lbShow(cur - 1); return; }
      if (t.closest('[data-fc-lb-next]')) { e.stopPropagation(); lbShow(cur + 1); return; }
      if (lb && t === lb) { lbClose(); return; }
      if (t.closest('[data-fc-main]')) { lbShow(cur); return; }
    });

    if (mainWrap) {
      mainWrap.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lbShow(cur); }
      });
    }
    document.addEventListener('keydown', function (e) {
      if (!lb || !lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbShow(cur - 1);
      else if (e.key === 'ArrowRight') lbShow(cur + 1);
    });

    /* main video: play only while on screen */
    if (mainWrap && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        mainInView = !!(en[0] && en[0].isIntersecting);
        mainVideoSync();
      }, { threshold: 0.5 }).observe(mainWrap);
    }
    try {
      var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var onRm = function () { if (MEDIA.length) showMainMedia(MEDIA[cur]); };
      if (rmq && rmq.addEventListener) rmq.addEventListener('change', onRm);
      else if (rmq && rmq.addListener) rmq.addListener(onRm);
    } catch (e) {}

    var rate = qs('[data-fc-rate]', root);
    if (rate) {
      rate.addEventListener('click', function (e) {
        var target = document.getElementById('reviews') || document.querySelector('[id$="__kit_reviews"], [id$="-kit_reviews"]');
        if (target) {
          e.preventDefault();
          try { target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' }); }
          catch (e1) { target.scrollIntoView(); }
        }
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (hasQuote()) {
          e.preventDefault();
          updateQuote();
          if (qPanel) {
            qPanel.open = true;
            try { qPanel.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' }); }
            catch (e1) { qPanel.scrollIntoView(); }
            var first = qs('input[name="contact[Name]"]', qPanel);
            if (first) first.focus();
          } else {
            var u = quoteUrl();
            if (u) window.location.href = u;
          }
          track('flatpack_quote_requested', {});
          return;
        }
        var missing = null;
        GROUPS.forEach(function (g) {
          if (missing || g.selection === 'multi' || !g.required) return;
          if (!sel[g.key]) missing = g;
        });
        if (missing) {
          e.preventDefault();
          if (live) live.textContent = 'Choose a ' + (missing.property || missing.title || missing.key) + ' before adding the kit to your cart.';
          var el = document.getElementById('ufc-g-' + missing.key);
          if (el) { el.scrollIntoView(); el.focus(); }
          return;
        }
        if (!window.fetch) return; /* let the native post through */
        e.preventDefault();
        addToCart();
      });
    }

    if (barBtn && atc) {
      barBtn.addEventListener('click', function () { atc.click(); });
    }

    if (qForm) {
      qForm.addEventListener('submit', function () { updateQuote(); track('flatpack_quote_requested', {}); });
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var byt = t.closest('[data-fc-byt]');
      if (byt) track('build_your_troopy_clicked', { selected_value: byt.getAttribute('href') || '' });
    });

    /* sticky bar. Never allowed to sit over the last option group. */
    function showBar(on) {
      if (!bar) return;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (barBtn) {
        if (on) barBtn.removeAttribute('tabindex');
        else barBtn.setAttribute('tabindex', '-1');
      }
      root.style.paddingBottom = on ? (bar.offsetHeight + 16) + 'px' : '';
    }
    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        showBar(!en[0].isIntersecting);
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(atc);
    }

    /* ---------------- start ---------------- */

    readDom();
    applyConfig(window.location.search, false);
    update('load');
    /* Start on the same photo the section server rendered: the media note with
       role hero, else the first image. Without this the module would snap the
       gallery back to image 0 on load whenever the hero note is not image 0. */
    for (var mi = 0; mi < MEDIA.length; mi++) {
      if (MEDIA[mi].role === 'hero') { cur = mi; break; }
    }
    if (MEDIA.length) setMain(cur, true);
    captureAttribution();

    if (doneCard) {
      if (qForm) qForm.classList.add('ufc__qform--done');
      try { doneCard.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' }); }
      catch (e) {}
      doneCard.focus();
    }
  }

  function bootAll() {
    qsa('[data-fc-root]').forEach(boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
